<template>
  <Modal v-model="show" :title="'售后信息编辑'" :mask-closable="false" :closable='false' width="700">
    <Form :model="form" ref="form" :rules="rules" :label-width="120" inline>
	  <FormItem label="联系人:" prop="contactsIdList">
	  		  <Select v-model="form.contactsIdList" multiple style="width:465px">
	  		          <Option v-for="item in contactsData" :value="item.value" :key="item.value">{{ item.name }}</Option>
	  		  </Select>
	  </FormItem>
	  <FormItem label="售后着装:" prop="afterSalesAttire">
        <RadioGroup v-model="form.afterSalesAttire" style="width: 400px">
          <Radio :label="item.value" v-for="(item,index) in afterSalesAttireData" :key="index"><span>{{item.name}}</span></Radio>
        </RadioGroup>
      </FormItem>
	  <FormItem label="工具:" prop="tool">
	    <RadioGroup v-model="form.tool" style="width: 400px">
	      <Radio :label="item.value" v-for="(item,index) in toolData" :key="index"><span>{{item.name}}</span></Radio>
	    </RadioGroup>
	  </FormItem>
	  <FormItem label="人员安全:" prop="personnelSafetyList">
	    <CheckboxGroup v-model="form.personnelSafetyList" style="width:400px" @on-change="checkShow">
	      <Checkbox :label="item.value" border v-for="item in personnelSafetyData" style="margin-bottom: 5px">{{item.name}}</Checkbox>
	    </CheckboxGroup>
	  </FormItem>
	  <FormItem label="其他要求:" prop="other" v-if="showOther">
	    <Input v-model="form.other" type="text" :maxlength="200" placeholder="请输入" style="width: 465px"></Input>
	  </FormItem>
      <FormItem label="车辆入场需知:" prop="vehicleEntryNotice">
        <Input v-model="form.vehicleEntryNotice" type="textarea" :maxlength="200" placeholder="请输入" style="width: 465px"></Input>
      </FormItem>
    </Form>
    <Spin size="large" fix v-show="spinShow"></Spin>
    <div slot="footer">
      <Button @click="close()" class="close-btn">关闭</Button>
      <Button @click="submit()" type="primary" :disabled="spinShow" class="close-btn" v-if="!isDisable">提交</Button>
    </div>
  </Modal>
</template>
<script>
export default {
  name: 'CreateAfterSales',
  props: {
    show: Boolean, //弹窗 窗口显示
    customerId: Number,
	quotationId: Number,
	isDetail:Boolean
  },
  data() {
    return {
	  accept: 'image/*',
	  format: ['jpg', 'pdf', 'png', 'jpeg'],
      form: {
	    afterSalesAttire:null,
		tool:null,
		personnelSafetyList:[],
		contactsIdList:[],
		vehicleEntryNotice:'',
        customerId: this.customerId,
		id:this.quotationId
      },
      rules: {
        afterSalesAttire: [{ required: true, message: '请选择', trigger: 'blur,change', type: 'number' }],
        contactsIdList: [
          { required: true, message: '请选择', trigger: 'blur,change', type: 'array' },
        ],
		personnelSafetyList: [
		  { required: true, message: '请选择', trigger: 'blur,change', type: 'array' },
		],
		tool: [
		  { required: true, message: '请选择', trigger: 'blur,change', type: 'number' },
		],
		
        vehicleEntryNotice: [
          { required: false, message: '请输入', trigger: 'blur,change', type: 'string' },
        ],
      },
      afterSalesAttireData: [], //
      contactsData: [], //
      personnelSafetyData: [], //
      toolData: [], //
	  showOther:false,
      spinShow: false,
	  isDisable:false,
    }
  },
  mounted() {
    if (this.customerId) {
      this.spinShow = true
      this.getUser()
    }
	if(this.quotationId){
		this.getDetail()
	}
	if(this.isDetail){
		this.isDisable=this.isDetail
	}
  },
  methods: {
    // 关闭弹窗
    close(refresh) {
	  this.form={
	    afterSalesAttire:null,
	    tool:null,
	    personnelSafetyList:[],
	    contactsIdList:[],
	    vehicleEntryNotice:'',
        customerId: this.customerId,
		id:0
      }
      this.$refs['form'].resetFields()
      this.$emit('close', refresh)
    },
    //   提交记录
    submit() {
      let _this = this
      this.$refs['form'].validate(async (valid) => {
        if (valid) {
			let files = []
			// if (this.form.模板_Files.length > 0) {
			//   this.form.模板_Files.map((file) => {
			//     files.push(file.fileGuids)
			//   })
			//   this.form.templateGuids = files.join(',')
			// }
          this.spinShow = true
		  var url=''
		  if(this.form.id!=null && this.form.id!=0){
		     url='/api/services/app/CustomerAfterSalesApiService/Update'
			 let { data } = await this.$Ajax.put(
			   url,
			   this.form
			 )
			 if (data.success) {
			   this.$Message.success({
			     content: '编辑成功',
			   })
			   _this.close(true)
			 }
		 }
		  else {
		      url='/api/services/app/CustomerAfterSalesApiService/Create'
			  let { data } = await this.$Ajax.post(
				url,
				this.form
			  )
			  if (data.success) {
				this.$Message.success({
				  content: '新建成功',
				})
				_this.close(true)
			  }
		  }
          this.spinShow = false
        }
      })
    },
    //   获取下拉框数据
    async getUser() {
      const { data } = await this.$Ajax.get(
        `/api/services/app/CustomerAfterSalesApiService/GetAfterSalesMgrInitData?customerId=${this.customerId}`
      )
      this.contactsData = data.result.contactsData
      this.afterSalesAttireData = data.result.afterSalesAttireData
      this.personnelSafetyData = data.result.personnelSafetyData
      this.toolData = data.result.toolData
	  this.spinShow = false
    },
	async getDetail() {
	  const { data } = await this.$Ajax.get(
	    `/api/services/app/CustomerAfterSalesApiService/GetDetailById?id=${this.quotationId}`
	  )
	  this.form = data.result
	  this.checkShow()
	  this.spinShow = false
	},
	// ? TableRowAdd 添加 添加一行
	checkShow() {
	  // 判断是否有正处于编辑状态的数据
	  if (
	  this.form.personnelSafetyList.some((item) => {return item == this.$constDefinition['人员安全_其他']})
	  ) {
	    this.showOther= true
	  }
	  else{
		  this.showOther= false
	  }
	},
  },
}
</script>